import type { FaireProductEntity } from "../../entity_types/product";

export const p_e3cp6cz5rm: FaireProductEntity = {
  token: "p_e3cp6cz5rm",
  type: "product",
  name: "Sea Salt & Kelp Dark Chocolate Bar (2.1 oz)",
  brandName: "Barnacle Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/1ae92e5c5250017284dd701d1e9a3ff24a7ff966df4e138ace89d14877a21a99.jpeg",
  priceDollars: 3.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e8045f20a70c1cfd59e2b3b26cd8fbe8e0f20f54af82748301119b53ffe97140.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
